import React from 'react';
import Header from './Header';
import Footer from './Footer';
import {BOOKING_WIDGET_URL,EMAIL_US,CONTACT_EMAIL} from '../siteConfig';

function BookPage() {
  return (
    <div className="site-shell">
      <Header />
      <main>
        <section className="page-hero">
          <span className="kicker">Book a call</span>
          <h1>Pick a time. <em>We will do the rest.</em></h1>
          <p>
            A free 30-minute call. Tell us how your business runs and what keeps slipping through the cracks, and we will tell you what would help most.
          </p>
        </section>
        <section className="section book-section" style={{paddingTop: 10}}>
          <div className="book-frame">
            <iframe
              src={BOOKING_WIDGET_URL}
              title="Book a call with Handle My Tech"
              loading="lazy"
            />
          </div>
          <p className="service-note">
            Prefer email? Write to <a className="footer-link" href={EMAIL_US}>{CONTACT_EMAIL}</a>
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default BookPage;
